// City data configuration for service area landing pages
// Each city has custom content for local SEO optimization

export const cityData = {
  everett: {
    name: "Everett",
    county: "Snohomish County",
    slug: "everett-personal-injury-lawyer",
    population: "115,000+",
    description: "As my home office location, I serve Everett and all of Snohomish County. From I-5 and Highway 2 accidents to maritime injuries at the Port of Everett, I help my neighbors recover fair compensation for their injuries.",
    landmarks: ["Downtown Everett", "Everett Mall", "Port of Everett", "Boeing Everett", "Paine Field"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Everett?",
        answer: "I work on a contingency fee basis—you pay nothing upfront. My fee (typically 33-40%) only applies if we win your case. This makes quality legal representation accessible to all Everett residents."
      },
      {
        question: "What should I do after a car accident in Everett?",
        answer: "First, ensure safety and call 911. Document the scene with photos, exchange information with other drivers, and get witness contacts. Seek medical attention within 24-72 hours even if you feel fine. Then contact me before speaking with insurance companies."
      },
      {
        question: "How long do I have to file a personal injury claim in Everett?",
        answer: "Washington law generally gives you three years from the date of injury. Claims against the City of Everett, Snohomish County, or other government entities require filing within 60 days. Contact me promptly to protect your rights."
      },
      {
        question: "Do you handle maritime injury cases at the Port of Everett?",
        answer: "Yes. I specialize in maritime injuries and Jones Act claims. If you were injured working at the Port of Everett, on a fishing vessel, or any maritime setting, I understand the unique laws that protect you."
      },
      {
        question: "What types of cases do you handle in Everett?",
        answer: "I handle car accidents, motorcycle crashes, maritime injuries, first responder cases, slip and falls, and wrongful death throughout Everett and Snohomish County. As a local attorney, I'm deeply familiar with our community."
      }
    ]
  },
  seattle: {
    name: "Seattle",
    county: "King County",
    slug: "seattle-personal-injury-lawyer",
    population: "800,000+",
    description: "As Washington's largest city, Seattle sees thousands of personal injury cases each year. From I-5 and I-90 accidents to waterfront maritime injuries, I help Seattle residents get the compensation they deserve.",
    landmarks: ["Downtown Seattle", "Capitol Hill", "Ballard", "West Seattle", "University District"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Seattle?",
        answer: "I work on a contingency fee basis, meaning you pay nothing upfront. My fee is a percentage of your settlement—typically 33-40%—and you only pay if we win your case. This makes quality legal representation accessible to all Seattle residents regardless of their financial situation."
      },
      {
        question: "What should I do after a car accident in Seattle?",
        answer: "First, ensure everyone's safety and call 911. Document the scene with photos, exchange information with other drivers, and get contact details from witnesses. Seek medical attention within 24-72 hours even if you feel fine—some injuries take time to manifest. Then contact a personal injury attorney before speaking with insurance companies."
      },
      {
        question: "How long do I have to file a personal injury claim in Seattle?",
        answer: "In Washington State, you generally have three years from the date of injury to file a personal injury lawsuit. However, claims against government entities (like King County Metro) require filing within 60 days. Don't wait—evidence fades and witnesses forget over time."
      },
      {
        question: "Can I handle my Seattle injury case without a lawyer?",
        answer: "While you can represent yourself, studies show that injured people who hire attorneys receive 3-3.5 times more compensation on average—even after attorney fees. Insurance companies have teams of adjusters and lawyers working to minimize payouts. Having an experienced advocate levels the playing field."
      },
      {
        question: "What types of cases do you handle in Seattle?",
        answer: "I handle car accidents, motorcycle crashes, maritime/Jones Act injuries, first responder injuries, slip and falls, and wrongful death cases throughout Seattle and King County. Whether your injury occurred on I-5, at the Port of Seattle, or in a local business, I can help."
      }
    ]
  },
  spokane: {
    name: "Spokane",
    county: "Spokane County",
    slug: "spokane-personal-injury-lawyer",
    population: "230,000+",
    description: "Spokane, Eastern Washington's largest city, presents unique personal injury challenges from icy winter roads to industrial accidents. I help Spokane residents navigate the legal process and recover fair compensation.",
    landmarks: ["Downtown Spokane", "South Hill", "North Side", "Spokane Valley", "Cheney"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Spokane?",
        answer: "I work on a contingency fee basis—you pay nothing unless we win. My fee is typically 33-40% of your settlement. This means Spokane residents can access experienced legal representation without any upfront costs or financial risk."
      },
      {
        question: "What are common causes of car accidents in Spokane?",
        answer: "Spokane's winter weather contributes to many accidents—ice, snow, and reduced visibility on I-90 and Division Street cause numerous crashes each year. Distracted driving, speeding, and drunk driving are also major factors. Whatever caused your accident, I can help you pursue compensation."
      },
      {
        question: "How long do I have to file a personal injury claim in Spokane?",
        answer: "Washington's statute of limitations gives you three years from the date of injury to file a lawsuit. However, if your claim involves the City of Spokane or Spokane County, you must file a tort claim within 60 days. Contact an attorney promptly to protect your rights."
      },
      {
        question: "Do you travel to Spokane for cases?",
        answer: "Yes! While my office is in Everett, I represent clients throughout Washington State, including Spokane and all of Eastern Washington. I handle much of the process remotely and travel for depositions, mediations, and court appearances as needed."
      },
      {
        question: "What compensation can I recover for my Spokane injury?",
        answer: "Depending on your case, you may recover medical expenses (past and future), lost wages, pain and suffering, property damage, and loss of quality of life. In cases of extreme negligence, punitive damages may also be available."
      }
    ]
  },
  vancouver: {
    name: "Vancouver",
    county: "Clark County",
    slug: "vancouver-wa-personal-injury-lawyer",
    population: "199,000+",
    description: "Vancouver, Washington sits at the crossroads of I-5 and I-205, seeing heavy traffic and unfortunately many accidents. I help Clark County residents injured in crashes, workplace incidents, and other accidents get the compensation they need.",
    landmarks: ["Downtown Vancouver", "Salmon Creek", "Felida", "Hazel Dell", "Camas"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Vancouver, WA?",
        answer: "I work on contingency—no upfront costs, and you only pay if we win. My fee is a percentage of your recovery (typically 33-40%). This allows Vancouver residents to pursue justice without financial barriers."
      },
      {
        question: "I was injured in a crash on I-5 near Vancouver. Can you help?",
        answer: "Absolutely. I-5 through Vancouver is one of the most accident-prone stretches in Washington, especially near the I-205 interchange. I regularly handle cases from crashes on I-5, I-205, SR-14, and throughout Clark County."
      },
      {
        question: "How long do I have to file a claim in Vancouver, WA?",
        answer: "You have three years from the date of injury to file a personal injury lawsuit in Washington. If the at-fault party is a government entity (like WSDOT or C-TRAN), you must file a claim within 60 days. Don't delay—contact an attorney right away."
      },
      {
        question: "What if I was partially at fault for my accident in Vancouver?",
        answer: "Washington follows 'pure comparative negligence' rules. You can still recover damages even if you were partially at fault—your compensation is simply reduced by your percentage of fault. For example, if you're 20% at fault on a $100,000 case, you'd receive $80,000."
      },
      {
        question: "Do you handle cases in both Washington and Oregon?",
        answer: "I'm licensed in Washington State and handle cases throughout Washington, including Vancouver and Clark County. If your accident occurred in Oregon, I can refer you to a trusted colleague across the river."
      }
    ]
  },
  bellevue: {
    name: "Bellevue",
    county: "King County",
    slug: "bellevue-personal-injury-lawyer",
    population: "156,000+",
    description: "Bellevue's rapid growth has brought increased traffic on I-405, I-90, and throughout downtown. From tech worker commute accidents to construction site injuries, I help Bellevue residents recover compensation for their injuries.",
    landmarks: ["Downtown Bellevue", "Crossroads", "Factoria", "Somerset", "Eastgate"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Bellevue?",
        answer: "I charge no upfront fees—I work on contingency. You only pay (typically 33-40% of your settlement) if we win your case. This makes experienced legal representation accessible to all Bellevue residents."
      },
      {
        question: "What should I do after a car accident on I-405 in Bellevue?",
        answer: "Move to safety if possible, call 911, document the scene with photos, and exchange information with other drivers. Seek medical attention promptly. Contact a personal injury attorney before giving recorded statements to insurance companies."
      },
      {
        question: "How long do I have to file a personal injury claim in Bellevue?",
        answer: "Washington law provides three years from the date of injury to file a lawsuit. Claims against government entities require a 60-day notice. I recommend contacting an attorney within weeks of your accident to preserve evidence."
      },
      {
        question: "Can I sue if I was injured at a Bellevue construction site?",
        answer: "Yes, if your injury resulted from someone else's negligence—whether a contractor, property owner, or equipment manufacturer. Construction site injuries can involve complex liability issues, making experienced legal representation important."
      },
      {
        question: "What types of personal injury cases do you handle in Bellevue?",
        answer: "I handle car and motorcycle accidents, slip and falls, workplace injuries, and wrongful death throughout Bellevue and the Eastside. I also specialize in maritime injuries and first responder cases."
      }
    ]
  },
  kent: {
    name: "Kent",
    county: "King County",
    slug: "kent-personal-injury-lawyer",
    population: "137,000+",
    description: "Kent's position in the heart of the Green River Valley makes it a hub for warehouses, distribution centers, and the accidents that come with heavy truck traffic. I help Kent residents injured in crashes and workplace incidents.",
    landmarks: ["Downtown Kent", "East Hill", "West Hill", "Kent Station", "ShoWare Center"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Kent?",
        answer: "Zero upfront. I work on contingency, meaning I only get paid when you get paid. My fee is typically 33-40% of your settlement, making quality representation accessible to all Kent residents."
      },
      {
        question: "I was hit by a semi-truck in Kent. What should I do?",
        answer: "Truck accidents in Kent's industrial corridor are complex, often involving multiple liable parties. Seek medical attention immediately, then contact a personal injury attorney. Evidence like driver logs and truck maintenance records must be preserved quickly."
      },
      {
        question: "How long do I have to file an injury claim in Kent?",
        answer: "Three years from the injury date under Washington law. However, truck accident evidence can disappear quickly—companies may repair vehicles or overwrite electronic logs. Contact an attorney as soon as possible."
      },
      {
        question: "Can I sue if I was injured at a Kent warehouse?",
        answer: "If you're a worker injured on the job, workers' compensation typically applies. However, if a third party (like a trucking company or equipment manufacturer) caused your injury, you may have a separate personal injury claim worth pursuing."
      },
      {
        question: "What compensation can I recover for my Kent injury?",
        answer: "You may recover medical expenses, lost wages, pain and suffering, and property damage. In serious cases, future medical costs and loss of earning capacity are also compensable. I'll evaluate your case and pursue maximum compensation."
      }
    ]
  },
  renton: {
    name: "Renton",
    county: "King County",
    slug: "renton-personal-injury-lawyer",
    population: "105,000+",
    description: "Renton sees heavy traffic from Boeing workers, commuters, and I-405 travelers. From The Landing to the Highlands, I help Renton residents injured in accidents pursue the compensation they deserve.",
    landmarks: ["Downtown Renton", "The Landing", "Renton Highlands", "Fairwood", "Kennydale"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Renton?",
        answer: "I charge nothing upfront. My contingency fee (typically 33-40%) only applies if we win your case. Renton residents can pursue justice without financial risk."
      },
      {
        question: "I was injured in a crash near Boeing in Renton. Can you help?",
        answer: "Yes. The area around Boeing and the I-405/SR-167 interchange sees frequent accidents due to shift-change traffic. I've helped many Renton residents injured in this area recover compensation."
      },
      {
        question: "How long do I have to file a personal injury claim in Renton?",
        answer: "Washington's three-year statute of limitations applies. For claims against the City of Renton or other government entities, you must file within 60 days. Contact an attorney promptly."
      },
      {
        question: "What if the at-fault driver in my Renton accident was uninsured?",
        answer: "Your own uninsured/underinsured motorist (UIM) coverage may apply. I can help you navigate this process and maximize your recovery from your own insurance company."
      },
      {
        question: "Do you handle slip and fall cases in Renton?",
        answer: "Yes. Whether you fell at The Landing, a grocery store, or a private property in Renton, I can evaluate your premises liability case and help you pursue compensation from negligent property owners."
      }
    ]
  },
  "federal-way": {
    name: "Federal Way",
    county: "King County",
    slug: "federal-way-personal-injury-lawyer",
    population: "100,000+",
    description: "Federal Way's location along I-5 between Seattle and Tacoma means heavy traffic and frequent accidents. I help Federal Way residents injured in crashes and other incidents recover fair compensation.",
    landmarks: ["The Commons", "Federal Way City Center", "Dash Point", "Twin Lakes", "Steel Lake"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Federal Way?",
        answer: "Nothing upfront. I work on contingency—typically 33-40% of your settlement—and only collect if we win. This makes experienced legal help accessible to all Federal Way residents."
      },
      {
        question: "What causes most car accidents in Federal Way?",
        answer: "I-5 congestion, SR-99 traffic, and Pacific Highway accidents are common. Rear-end collisions, lane-change accidents, and weather-related crashes frequently occur. Whatever caused your accident, I can help."
      },
      {
        question: "How long do I have to file a claim in Federal Way?",
        answer: "Three years from your injury date under Washington law. Government entity claims (City of Federal Way, Sound Transit) require 60-day notice. Contact an attorney quickly to protect your rights."
      },
      {
        question: "Can I get compensation if I was injured at a Federal Way business?",
        answer: "Yes, if the business owner's negligence caused your injury. Slip and falls, inadequate security, and other premises liability cases may entitle you to compensation for medical bills, lost wages, and pain and suffering."
      },
      {
        question: "Do you handle cases throughout South King County?",
        answer: "Absolutely. I represent clients in Federal Way, Auburn, Kent, Renton, and throughout South King County. I handle car accidents, slip and falls, and all personal injury matters."
      }
    ]
  },
  "spokane-valley": {
    name: "Spokane Valley",
    county: "Spokane County",
    slug: "spokane-valley-personal-injury-lawyer",
    population: "100,000+",
    description: "Spokane Valley residents face unique challenges from I-90 accidents to workplace injuries in the Valley's industrial areas. I help Eastern Washington residents pursue fair compensation for their injuries.",
    landmarks: ["Spokane Valley Mall", "Mirabeau Park", "Greenacres", "Otis Orchards", "Liberty Lake"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Spokane Valley?",
        answer: "I work on contingency—no upfront costs. My fee (33-40%) only applies when we win. Spokane Valley residents can pursue their cases without financial risk."
      },
      {
        question: "I was injured in a crash on I-90 in Spokane Valley. What now?",
        answer: "Document your injuries, seek medical attention, and contact a personal injury attorney before speaking with insurance companies. I-90 accidents often involve complex factors like commercial trucks and multi-vehicle pileups."
      },
      {
        question: "How long do I have to file a claim in Spokane Valley?",
        answer: "Washington law provides three years to file a personal injury lawsuit. Claims against government entities require 60-day notice. Contact an attorney promptly to protect your rights."
      },
      {
        question: "Do you travel to Spokane Valley for cases?",
        answer: "Yes. While based in Everett, I represent clients throughout Washington State. I handle much of the process remotely and travel for key events like depositions and mediations."
      },
      {
        question: "What types of injuries do you handle in Spokane Valley?",
        answer: "Car and truck accidents, motorcycle crashes, slip and falls, workplace injuries, and wrongful death. I also specialize in maritime injuries for workers on the Columbia River."
      }
    ]
  },
  kirkland: {
    name: "Kirkland",
    county: "King County",
    slug: "kirkland-personal-injury-lawyer",
    population: "95,000+",
    description: "Kirkland's waterfront charm comes with busy roads and serious traffic on I-405 and the Cross Kirkland Corridor. I help Kirkland residents injured in accidents recover the compensation they deserve.",
    landmarks: ["Downtown Kirkland", "Juanita", "Totem Lake", "Houghton", "Finn Hill"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Kirkland?",
        answer: "I charge no upfront fees. Working on contingency (33-40%), I only get paid when you get paid. Quality legal representation is accessible to all Kirkland residents."
      },
      {
        question: "I was injured in a pedestrian accident in downtown Kirkland. Can you help?",
        answer: "Yes. Downtown Kirkland's busy streets and waterfront areas see pedestrian accidents regularly. I can help you pursue compensation from negligent drivers."
      },
      {
        question: "How long do I have to file a personal injury claim in Kirkland?",
        answer: "Three years under Washington's statute of limitations. Claims against the City of Kirkland require a 60-day tort claim notice. Don't delay—contact an attorney promptly."
      },
      {
        question: "What if I was injured in a boating accident on Lake Washington near Kirkland?",
        answer: "Boating accidents may fall under maritime law or state law depending on the circumstances. I have extensive maritime injury experience and can evaluate your case."
      },
      {
        question: "Do you handle cases on the Eastside?",
        answer: "Yes. I represent clients throughout the Eastside including Kirkland, Bellevue, Redmond, and Woodinville. Car accidents, slip and falls, and all personal injury matters."
      }
    ]
  },
  yakima: {
    name: "Yakima",
    county: "Yakima County",
    slug: "yakima-personal-injury-lawyer",
    population: "96,000+",
    description: "Yakima's agricultural industry and I-82 corridor present unique injury risks. I help Central Washington residents injured in crashes, farm accidents, and other incidents pursue fair compensation.",
    landmarks: ["Downtown Yakima", "West Valley", "Terrace Heights", "Moxee", "Selah"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Yakima?",
        answer: "Nothing upfront. I work on contingency (33-40%), which means you only pay if we win. Yakima residents can pursue their cases without financial barriers."
      },
      {
        question: "I was injured in a farm equipment accident near Yakima. Can you help?",
        answer: "Agricultural accidents can involve workers' compensation, product liability, and third-party negligence claims. I can evaluate your case and help you pursue all available compensation."
      },
      {
        question: "How long do I have to file a claim in Yakima?",
        answer: "Washington's three-year statute of limitations applies. For claims against Yakima County or other government entities, a 60-day notice is required. Contact an attorney right away."
      },
      {
        question: "Do you handle cases in Central Washington?",
        answer: "Yes. While based in Everett, I represent clients throughout Washington State including Yakima, Ellensburg, and the Tri-Cities. I travel for depositions and court appearances."
      },
      {
        question: "What compensation can I recover for my Yakima injury?",
        answer: "Depending on your case: medical expenses, lost wages, pain and suffering, and property damage. Serious injuries may also warrant compensation for future medical care and lost earning capacity."
      }
    ]
  },
  kennewick: {
    name: "Kennewick",
    county: "Benton County",
    slug: "kennewick-personal-injury-lawyer",
    population: "85,000+",
    description: "Kennewick and the Tri-Cities area sees injuries from I-82 and Highway 395 accidents to industrial incidents at Hanford and local businesses. I help Tri-Cities residents pursue fair compensation.",
    landmarks: ["Downtown Kennewick", "Columbia Center", "Southridge", "Canyon Lakes", "Zintel Canyon"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Kennewick?",
        answer: "I work on contingency—no upfront costs. My fee (33-40%) only applies if we win your case. Kennewick residents can pursue justice without financial risk."
      },
      {
        question: "I was injured in an accident near Hanford. Can you help?",
        answer: "Industrial accidents near Hanford and the Tri-Cities may involve multiple liable parties. I can help you navigate workers' compensation and potential third-party liability claims."
      },
      {
        question: "How long do I have to file a claim in Kennewick?",
        answer: "Three years from your injury date under Washington law. Federal facility claims (like Hanford) may have different requirements. Contact an attorney promptly to understand your options."
      },
      {
        question: "Do you handle cases in the Tri-Cities area?",
        answer: "Yes. I represent clients in Kennewick, Richland, Pasco, and throughout the Tri-Cities. I travel for key case events and handle much of the process remotely."
      },
      {
        question: "What types of cases do you handle in Kennewick?",
        answer: "Car accidents, truck crashes, industrial injuries, slip and falls, and wrongful death. I also handle maritime cases for workers injured on the Columbia River."
      }
    ]
  },
  auburn: {
    name: "Auburn",
    county: "King/Pierce County",
    slug: "auburn-personal-injury-lawyer",
    population: "85,000+",
    description: "Auburn sits at the King-Pierce county line with heavy traffic on SR-167, SR-18, and C Street. I help Auburn residents injured in crashes, workplace accidents, and other incidents recover fair compensation.",
    landmarks: ["Downtown Auburn", "Lakeland Hills", "Lea Hill", "West Hill", "Muckleshoot Casino"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Auburn?",
        answer: "Nothing upfront. I work on contingency (33-40%), so you only pay if we win. Auburn residents can pursue their cases without financial barriers."
      },
      {
        question: "I was injured in a crash on SR-167 in Auburn. Can you help?",
        answer: "Yes. SR-167 through Auburn sees frequent accidents due to commuter traffic and trucking. I've helped many Auburn residents injured on this corridor recover compensation."
      },
      {
        question: "How long do I have to file a claim in Auburn?",
        answer: "Three years under Washington law. Claims against the City of Auburn or other government entities require 60-day notice. Contact an attorney right away to protect your rights."
      },
      {
        question: "Can I sue if I was injured at the Muckleshoot Casino?",
        answer: "Tribal casino injuries can involve complex jurisdictional issues. I can evaluate your case and help you understand your options for pursuing compensation."
      },
      {
        question: "Do you handle cases in Auburn and South King County?",
        answer: "Yes. I represent clients throughout Auburn, Kent, Federal Way, and South King County for car accidents, slip and falls, and all personal injury matters."
      }
    ]
  },
  pasco: {
    name: "Pasco",
    county: "Franklin County",
    slug: "pasco-personal-injury-lawyer",
    population: "80,000+",
    description: "Pasco's rapid growth in the Tri-Cities brings increased traffic and accidents. I help Franklin County residents injured in crashes and other incidents pursue the compensation they deserve.",
    landmarks: ["Downtown Pasco", "Road 68", "Broadmoor", "Riverview", "West Pasco"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Pasco?",
        answer: "I charge nothing upfront. Working on contingency (33-40%), I only get paid when you win. Pasco residents can pursue their cases without financial risk."
      },
      {
        question: "I was injured crossing the Cable Bridge to Pasco. Can you help?",
        answer: "Yes. Accidents on the bridges connecting the Tri-Cities are common. I can help you pursue compensation from negligent drivers regardless of which side of the river you're from."
      },
      {
        question: "How long do I have to file a claim in Pasco?",
        answer: "Washington's three-year statute of limitations applies. Government claims require 60-day notice. Contact an attorney promptly to protect your rights."
      },
      {
        question: "Do you handle agricultural injury cases near Pasco?",
        answer: "Yes. Franklin County's agricultural industry brings unique injury risks. I can evaluate workers' compensation, product liability, and third-party negligence claims."
      },
      {
        question: "What compensation can I recover for my Pasco injury?",
        answer: "Medical expenses, lost wages, pain and suffering, and property damage. Serious injuries may warrant compensation for future medical care and diminished earning capacity."
      }
    ]
  },
  marysville: {
    name: "Marysville",
    county: "Snohomish County",
    slug: "marysville-personal-injury-lawyer",
    population: "75,000+",
    description: "Marysville's growth north of Everett means more I-5 traffic and accidents. As a Snohomish County attorney, I'm well-positioned to help Marysville residents recover compensation for their injuries.",
    landmarks: ["Downtown Marysville", "Smokey Point", "Lake Goodwin", "Lakewood", "Quilceda Village"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Marysville?",
        answer: "Nothing upfront. I work on contingency (33-40%), so you only pay if we win your case. Marysville residents can pursue their claims without financial barriers."
      },
      {
        question: "I was injured in a crash on I-5 near Smokey Point. Can you help?",
        answer: "Absolutely. I-5 through Marysville and Smokey Point sees heavy traffic and frequent accidents. As a Snohomish County attorney, I regularly handle cases from this area."
      },
      {
        question: "How long do I have to file a claim in Marysville?",
        answer: "Three years under Washington law. Claims against the City of Marysville or Snohomish County require 60-day notice. Contact me promptly to protect your rights."
      },
      {
        question: "You're in Everett—do you handle Marysville cases?",
        answer: "Yes! Marysville is just north of my Everett office, making it very convenient to serve Marysville residents. I handle car accidents, slip and falls, and all personal injury matters."
      },
      {
        question: "Can you help with a slip and fall at Quilceda Village outlets?",
        answer: "Yes. Retail premises liability cases require proving the property owner knew or should have known about the dangerous condition. I can evaluate your case and help you pursue compensation."
      }
    ]
  },
  redmond: {
    name: "Redmond",
    county: "King County",
    slug: "redmond-personal-injury-lawyer",
    population: "80,000+",
    description: "Redmond's tech campuses bring heavy traffic on SR-520, I-405, and Redmond Way. I help Eastside residents injured in crashes and other accidents recover the compensation they deserve.",
    landmarks: ["Downtown Redmond", "Overlake", "Education Hill", "Willows", "Bear Creek"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Redmond?",
        answer: "I charge no upfront fees. My contingency fee (33-40%) only applies if we win. Quality legal representation is accessible to all Redmond residents."
      },
      {
        question: "I was injured in a crash on SR-520 near Microsoft. Can you help?",
        answer: "Yes. The SR-520 corridor through Redmond sees frequent accidents due to tech campus traffic. I've helped many Eastside residents recover compensation for their injuries."
      },
      {
        question: "How long do I have to file a claim in Redmond?",
        answer: "Three years under Washington's statute of limitations. Claims against the City of Redmond require 60-day notice. Contact an attorney promptly to protect your rights."
      },
      {
        question: "I was injured while cycling on the Sammamish River Trail in Redmond. What are my options?",
        answer: "Bicycle accident cases may involve motorist negligence, trail maintenance issues, or other factors. I can evaluate your case and help you pursue appropriate compensation."
      },
      {
        question: "Do you handle cases throughout the Eastside?",
        answer: "Yes. I represent clients in Redmond, Kirkland, Bellevue, Woodinville, and throughout the Eastside for car accidents, slip and falls, and all personal injury matters."
      }
    ]
  },
  shoreline: {
    name: "Shoreline",
    county: "King County",
    slug: "shoreline-personal-injury-lawyer",
    population: "60,000+",
    description: "Shoreline's position between Seattle and Snohomish County means heavy Aurora Avenue and I-5 traffic. I help Shoreline residents injured in accidents pursue fair compensation.",
    landmarks: ["Aurora Square", "Richmond Beach", "Echo Lake", "Ridgecrest", "Briarcrest"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Shoreline?",
        answer: "Nothing upfront. I work on contingency (33-40%), so you only pay if we win. Shoreline residents can pursue their cases without financial risk."
      },
      {
        question: "Aurora Avenue is dangerous. Can you help if I was hit there?",
        answer: "Yes. Aurora Avenue (SR-99) through Shoreline has a high accident rate. Whether you were driving, walking, or cycling, I can help you pursue compensation from negligent parties."
      },
      {
        question: "How long do I have to file a claim in Shoreline?",
        answer: "Three years under Washington law. Claims against the City of Shoreline require 60-day notice. Contact an attorney right away to protect your rights."
      },
      {
        question: "Will the new light rail in Shoreline affect my case?",
        answer: "Construction zones can complicate liability. If Sound Transit construction contributed to your accident, additional parties may be liable. I can evaluate the circumstances."
      },
      {
        question: "Do you handle cases in North King County?",
        answer: "Yes. I represent clients in Shoreline, Lake Forest Park, Kenmore, and throughout North King County. Car accidents, slip and falls, and all personal injury matters."
      }
    ]
  },
  sammamish: {
    name: "Sammamish",
    county: "King County",
    slug: "sammamish-personal-injury-lawyer",
    population: "70,000+",
    description: "Sammamish's winding roads and growing population bring unique traffic challenges. I help Sammamish Plateau residents injured in accidents recover the compensation they deserve.",
    landmarks: ["Sammamish Commons", "Pine Lake", "Beaver Lake", "Klahanie", "Inglewood"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Sammamish?",
        answer: "I charge no upfront fees. Working on contingency (33-40%), I only get paid when you win. Quality legal representation is accessible to all Sammamish residents."
      },
      {
        question: "I was injured in a crash on Issaquah-Pine Lake Road. Can you help?",
        answer: "Yes. Sammamish's winding two-lane roads see frequent accidents, especially during commute hours. I can help you pursue compensation from negligent drivers."
      },
      {
        question: "How long do I have to file a claim in Sammamish?",
        answer: "Three years under Washington's statute of limitations. Claims against the City of Sammamish require 60-day notice. Contact an attorney promptly."
      },
      {
        question: "I was injured in a cycling accident on the trail around Lake Sammamish. What are my options?",
        answer: "Cycling accidents may involve motorist negligence, trail conditions, or other factors. I can evaluate your case and help you pursue appropriate compensation."
      },
      {
        question: "Do you handle cases on the Sammamish Plateau?",
        answer: "Yes. I represent clients throughout Sammamish, Issaquah, and the Eastside for car accidents, cycling accidents, slip and falls, and all personal injury matters."
      }
    ]
  },
  lakewood: {
    name: "Lakewood",
    county: "Pierce County",
    slug: "lakewood-personal-injury-lawyer",
    population: "65,000+",
    description: "Lakewood's proximity to Joint Base Lewis-McChord brings unique traffic patterns and injury scenarios. I help Lakewood residents and military families pursue fair compensation for their injuries.",
    landmarks: ["Lakewood Towne Center", "American Lake", "Steilacoom Lake", "Tillicum", "JBLM"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Lakewood?",
        answer: "Nothing upfront. I work on contingency (33-40%), so you only pay if we win your case. Lakewood residents can pursue their claims without financial barriers."
      },
      {
        question: "I'm military stationed at JBLM and was injured off-base. Can you help?",
        answer: "Yes. Military personnel injured in off-base car accidents have the same rights as civilian residents. I can help you pursue compensation from at-fault parties."
      },
      {
        question: "How long do I have to file a claim in Lakewood?",
        answer: "Three years under Washington law. Claims against the City of Lakewood or Pierce County require 60-day notice. Contact an attorney right away to protect your rights."
      },
      {
        question: "I was injured on I-5 near Lakewood. Can you help?",
        answer: "Yes. I-5 through Lakewood and near JBLM sees heavy traffic and frequent accidents. I can help you pursue compensation from negligent drivers."
      },
      {
        question: "Do you handle cases throughout Pierce County?",
        answer: "Yes. I represent clients in Lakewood, Tacoma, University Place, and throughout Pierce County for car accidents, slip and falls, and all personal injury matters."
      }
    ]
  },
  richland: {
    name: "Richland",
    county: "Benton County",
    slug: "richland-personal-injury-lawyer",
    population: "65,000+",
    description: "Richland's Hanford heritage brings unique workplace injury scenarios alongside typical traffic accidents. I help Tri-Cities residents pursue fair compensation for their injuries.",
    landmarks: ["Uptown Richland", "The Parkway", "Horn Rapids", "South Richland", "West Richland"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Richland?",
        answer: "I charge nothing upfront. My contingency fee (33-40%) only applies if we win. Richland residents can pursue justice without financial risk."
      },
      {
        question: "I was injured at Hanford. What are my options?",
        answer: "Hanford injuries may involve workers' compensation, federal claims, and third-party liability. I can evaluate your case and help you understand all available options."
      },
      {
        question: "How long do I have to file a claim in Richland?",
        answer: "Three years under Washington law for most cases. Federal facility claims may have different requirements. Contact an attorney promptly to understand your deadlines."
      },
      {
        question: "Do you handle cases in the Tri-Cities?",
        answer: "Yes. I represent clients in Richland, Kennewick, Pasco, and throughout the Tri-Cities. I travel for key case events and handle much of the process remotely."
      },
      {
        question: "I was injured in a boating accident on the Columbia River near Richland. Can you help?",
        answer: "Yes. Boating accidents may fall under maritime law or state law. I have extensive maritime injury experience and can evaluate your case."
      }
    ]
  },
  burien: {
    name: "Burien",
    county: "King County",
    slug: "burien-personal-injury-lawyer",
    population: "55,000+",
    description: "Burien's location near Sea-Tac Airport brings unique traffic patterns and accident scenarios. I help South King County residents injured in crashes and other incidents pursue fair compensation.",
    landmarks: ["Downtown Burien", "Boulevard Park", "White Center", "Normandy Park", "Sea-Tac"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Burien?",
        answer: "Nothing upfront. I work on contingency (33-40%), so you only pay if we win. Burien residents can pursue their cases without financial barriers."
      },
      {
        question: "I was injured in a crash near Sea-Tac Airport. Can you help?",
        answer: "Yes. The roads around Sea-Tac see heavy traffic and frequent accidents. I can help you pursue compensation from negligent drivers."
      },
      {
        question: "How long do I have to file a claim in Burien?",
        answer: "Three years under Washington law. Claims against the City of Burien or Port of Seattle require 60-day notice. Contact an attorney right away."
      },
      {
        question: "I was injured by a shuttle van at Sea-Tac. What are my options?",
        answer: "Commercial vehicle accidents may involve multiple liable parties—the driver, company, and potentially the Port of Seattle. I can evaluate your case and identify all responsible parties."
      },
      {
        question: "Do you handle cases in South King County?",
        answer: "Yes. I represent clients in Burien, SeaTac, Tukwila, Renton, and throughout South King County for car accidents, slip and falls, and all personal injury matters."
      }
    ]
  },
  lacey: {
    name: "Lacey",
    county: "Thurston County",
    slug: "lacey-personal-injury-lawyer",
    population: "55,000+",
    description: "Lacey's position in the Olympia metro area brings I-5 traffic and state government commuters. I help Thurston County residents injured in accidents pursue fair compensation.",
    landmarks: ["South Sound Center", "Hawks Prairie", "Woodland District", "Lacey Crossings", "Panorama City"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Lacey?",
        answer: "I charge nothing upfront. Working on contingency (33-40%), I only get paid when you win. Lacey residents can pursue their cases without financial risk."
      },
      {
        question: "I was injured in a crash on I-5 near Hawks Prairie. Can you help?",
        answer: "Yes. I-5 through Lacey and Hawks Prairie sees frequent accidents, especially near the outlet malls. I can help you pursue compensation from negligent drivers."
      },
      {
        question: "How long do I have to file a claim in Lacey?",
        answer: "Three years under Washington law. Claims against the City of Lacey, Thurston County, or the State of Washington require special notice. Contact an attorney promptly."
      },
      {
        question: "I'm a state employee injured in Lacey. What are my options?",
        answer: "State employees may have workers' compensation claims and potentially third-party liability claims if someone outside your employment caused the injury."
      },
      {
        question: "Do you handle cases in Thurston County?",
        answer: "Yes. I represent clients in Lacey, Olympia, Tumwater, and throughout Thurston County. I travel for depositions and court appearances as needed."
      }
    ]
  },
  olympia: {
    name: "Olympia",
    county: "Thurston County",
    slug: "olympia-personal-injury-lawyer",
    population: "55,000+",
    description: "As Washington's capital, Olympia sees state workers, legislators, and visitors navigating busy streets and I-5 traffic. I help Olympia residents injured in accidents pursue fair compensation.",
    landmarks: ["Downtown Olympia", "Capitol Campus", "Westside", "Eastside", "South Capitol"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Olympia?",
        answer: "Nothing upfront. I work on contingency (33-40%), so you only pay if we win your case. Olympia residents can pursue their claims without financial barriers."
      },
      {
        question: "I was injured on state property in Olympia. Can I sue?",
        answer: "Claims against the State of Washington have strict notice requirements and procedures. I can help you navigate the process and pursue compensation for your injuries."
      },
      {
        question: "How long do I have to file a claim in Olympia?",
        answer: "Three years under Washington law, but claims against the state or City of Olympia require early notice. Contact an attorney right away to protect your rights."
      },
      {
        question: "I was injured at the Port of Olympia. What are my options?",
        answer: "Port injuries may involve maritime law, premises liability, or workers' compensation depending on the circumstances. I have extensive maritime experience and can evaluate your case."
      },
      {
        question: "Do you travel to Olympia for cases?",
        answer: "Yes. While based in Everett, I represent clients throughout Washington State including Olympia and Thurston County. I travel for depositions and court appearances."
      }
    ]
  },
  edmonds: {
    name: "Edmonds",
    county: "Snohomish County",
    slug: "edmonds-personal-injury-lawyer",
    population: "50,000+",
    description: "Edmonds' charming downtown and busy ferry terminal bring unique traffic patterns. As a Snohomish County attorney, I'm well-positioned to help Edmonds residents recover compensation for their injuries.",
    landmarks: ["Downtown Edmonds", "Edmonds Ferry", "Perrinville", "Westgate", "Esperance"],
    faqs: [
      {
        question: "How much does a personal injury lawyer cost in Edmonds?",
        answer: "I charge nothing upfront. My contingency fee (33-40%) only applies if we win. Quality legal representation is accessible to all Edmonds residents."
      },
      {
        question: "I was injured near the Edmonds ferry terminal. Can you help?",
        answer: "Yes. The ferry terminal area sees heavy traffic and frequent accidents. I can help you pursue compensation from negligent drivers."
      },
      {
        question: "How long do I have to file a claim in Edmonds?",
        answer: "Three years under Washington law. Claims against the City of Edmonds or Washington State Ferries require early notice. Contact me promptly to protect your rights."
      },
      {
        question: "I was injured on a Washington State Ferry departing Edmonds. What are my options?",
        answer: "Ferry injuries may involve maritime law and claims against the state. I have extensive maritime experience and can help you navigate the process."
      },
      {
        question: "You're in Everett—do you handle Edmonds cases?",
        answer: "Absolutely! Edmonds is just south of my Everett office, making it very convenient to serve Edmonds residents. I handle car accidents, slip and falls, and all personal injury matters."
      }
    ]
  }
};

// Get all cities as an array
export const getAllCities = () => Object.values(cityData);

// Get city by slug
export const getCityBySlug = (slug) => {
  return Object.values(cityData).find(city => city.slug === slug);
};

// Services offered in all cities
export const services = [
  { name: "Car Accident Claims", icon: "Car", link: "/car-crashes" },
  { name: "Maritime & Jones Act Injuries", icon: "Anchor", link: "/maritime-injuries" },
  { name: "First Responder Injuries", icon: "Shield", link: "/first-responder-crashes" },
  { name: "Motorcycle Accidents", icon: "Bike", link: "/motorcycle-crashes" },
  { name: "Slip and Fall Injuries", icon: "AlertTriangle", link: "/slip-and-falls" },
  { name: "Wrongful Death Claims", icon: "Heart", link: "/wrongful-death" }
];
